module.exports = __webpack_public_path__ + "img/Ks.1b18d602.png";